import React, { useEffect, useState } from "react";
import ButtonLoader from "../../../../../../../components/ButtonLoader";
import Alerts from "../../../../../../../components/Alerts";
import { UserData } from "../../../../../network/api/UserData";
import { useAppContext } from "../../../../../../../context/AppContext";
import FileUpload from "../../../../../components/FileUpload";


export default function UpdateProfileForm({ setToastConfig, profile, setProfile, fileData, setFileData }) {
    const { updateUserData, setUpdateUserData } = useAppContext();

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isProfileEdited, setIsProfileEdited] = useState(false);

    const [profileForm, setProfileForm] = useState({
        id: profile?.id,
        fullname: profile?.fullname,
        displayname: profile?.displayname,
        phone: profile?.phone,
    });

    const raw = localStorage.getItem("userData");
    const userData = raw ? JSON.parse(raw) : null;


    const handleProfileChange = (e) => {
        const { name, value } = e.target;
        setProfileForm((prev) => ({
            ...prev,
            [name]: value,
        }));

        setIsProfileEdited(true);
    };

    const updateProfile = async (e) => {
        e.preventDefault();

        setIsLoading(true);
        setErrorMessage(null);
        setIsProfileEdited(false);

        try {
            const response = await UserData({ method: "PUT", formData: profileForm });

            if (response.status === "success") {
                // Update profile locally
                const updatedProfile = {
                    ...profile,
                    fullname: profileForm.fullname,
                    displayname: profileForm.displayname,
                    phone: profileForm.phone,
                };
                setProfile(updatedProfile);

                // Update localStorage directly
                if (profile.id === userData.user.userId) {
                    const updatedUserData = {
                        ...userData,
                        user: {
                            ...userData.user,
                            userName: profileForm.displayname,
                        },
                    };


                    localStorage.setItem("userData", JSON.stringify(updatedUserData));
                    setUpdateUserData(!updateUserData);
                }
            }

            setToastConfig({ visible: true, message: `${response.message} \n updating ${profile.displayname}s Profile `, type: (response.status) === "error" ? "danger" : response.status });
            setErrorMessage({ sts: response.status, message: response.message });


        } catch (err) {
            setErrorMessage({ code: 500, message: err.message || "Failed to load profile." });
        } finally {
            setIsLoading(false);

        }



    }

    useEffect(() => {
        if (fileData) {
            //console.log("File data changed:", fileData);
            const updateProfileImage = async () => {
                //console.log("File data changed:", fileData);
                try {
                    const response = await UserData({ method: "PUT", formData: { id: profile.id, image_id: fileData?.id } });

                    if (response.status === "success") {
                        const updatedProfile = {
                            ...profile,
                            image: fileData?.file_url,
                        };
                        
                        // Update localStorage directly
                        if (profile.id === userData.user.userId) {
                            const updatedUserData = {
                                ...userData,
                                user: {
                                    ...userData.user,
                                    avatar: fileData?.file_url,
                                },
                            };


                            localStorage.setItem("userData", JSON.stringify(updatedUserData));
                            setUpdateUserData(!updateUserData);
                        }

                        setProfile(updatedProfile);

                    }
                    setToastConfig({ visible: true, message: `${response.message} \n updating ${profile.displayname}s Profile Photo`, type: (response.status) === "error" ? "danger" : response.status });
                } catch (err) {
                    setToastConfig({ visible: true, message: `Error \n updating ${profile.displayname}s Profile Photo`,  status:"danger"});
                }finally {
                    setFileData(null);
                }
            };

            updateProfileImage();
        }

    }, [fileData, setFileData, profile, setProfile, setToastConfig, userData, updateUserData, setUpdateUserData])


    return (
        <form onSubmit={updateProfile}>

            {!isLoading && errorMessage && !isProfileEdited ?
                <Alerts type={errorMessage.sts === "success" ? "success" : "danger"} message={errorMessage.message} />
                : <></>}

            <div className="row pt-3">
                <div className="mb-3 col-md-6">
                    <label className="form-label">Email</label>
                    <input type="email" className="form-control disabled" value={profile?.email} name="email" disabled={true} />
                </div>
                <div className="mb-3 col-md-6">
                    <label className="form-label">Full Name</label>
                    <input type="text" onChange={handleProfileChange} className="form-control" value={profileForm?.fullname} name="fullname" />
                </div>
                <div className="mb-3 col-md-6">
                    <label className="form-label">Display Name</label>
                    <input type="text" onChange={handleProfileChange} className="form-control" value={profileForm?.displayname} name="displayname" />
                </div>
                <div className="mb-3 col-md-6">
                    <label className="form-label">Phone</label>
                    <input type="text" onChange={handleProfileChange} className="form-control" value={profileForm?.phone} name="phone" />
                </div>
                <div className="mb-3 col-md-12">
                    <label className="form-label">
                        <i className="fa-solid fa-image"></i>{" "}  Profile Image
                        </label>
                    <FileUpload owner={profile?.id} setFileData={setFileData} description={"Profile Image"}/>
                </div>
            </div>
            <div className="">
                <button className={`btn btn-primary ${!isProfileEdited || isLoading ? "disabled" : ""}`} type="submit" name="submitBTN">{isLoading ? <ButtonLoader /> : "Update Profile"}</button>
            </div>
        </form>
    );
} 